module.exports = __webpack_public_path__ + "img/icon_sb_select_star_google_t.8bf1595.svg";